// extracted by mini-css-extract-plugin
export default {"row-wrapper":"RouteRow_row-wrapper__8rjSh","leg":"RouteRow_leg__BqHMC"};